import React, {useCallback, useEffect, useState} from 'react';
import {Button, Form, Grid, Header, Icon, Input, Message, Segment, Select, Table} from 'semantic-ui-react';
import {SessionUser} from "../../../models/session-user";
import SessionStorage from "../../../store/session";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import useClientService from "../../../services/backoffice/hooks/useClientService";
import {ShortDto} from "../../../models/short-dto";
import {ClientDashboardDto} from "../../../models/clientDashboardDto";
import {ClientDashboardFilter} from "../../../filters/client-dashboard-filter";
import {EMes} from "../../../enums/eMes";
import {useDashboardService} from "../../../services/backoffice/hooks/useDashboardService";
import {useLocation} from "react-router-dom";
import StringUtils from "../../../shared/utils/string-utils";
import {DriverDataDto} from "../../../models/driverDataDto";
import CircularProgressBar from "../../../components/client-dashboard-graphs/progress-bar/CircularProgressBar";

const ClientDashboardPage = () => {
    const [clientDashboardData, setClientDashboardData] = useState<ClientDashboardDto>();
    const [error, setError] = useState<string>();
    const [clientId, setClientId] = useState<string>();
    const location = useLocation();
    const [loading, setLoading] = useState<boolean>(false);
    const queryParams = new URLSearchParams(location.search);
    const mesParam = queryParams.get("Year") ?? (new Date().getMonth() + 1).toString();
    const anoParam = queryParams.get("Month") ?? new Date().getFullYear().toString();
    const [filter, setFilter] = useState<ClientDashboardFilter>({
        Month: parseInt(mesParam),
        Year: parseInt(anoParam),
    })
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [clients, setClients] = useState<ShortDto[]>([]);
    const blockUI = useBlockUI();
    const {getAllClientsShortDto} = useClientService()
    const {getClientDashboardPerPeriod} = useDashboardService()
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    const [showFilters, setShowFilters] = useState(false);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };


    const getClientDashboardData = useCallback(async () => {
        try {
            setLoading(true)
            if (clientId && filter.Month && filter.Year) {
                const response = await getClientDashboardPerPeriod(clientId, filter).finally(() => {
                    setLoading(false)
                });
                setClientDashboardData(response);
            }
        } catch (error) {
            setClientDashboardData(undefined);
        } finally {
            setLoading(false)
        }
    }, [filter, getClientDashboardPerPeriod]);

    useEffect(() => {
        getClientDashboardData();
    }, []);


    useEffect(() => {
        function ListClients() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
        }
        ListClients()
    }, [])

    return <div>
        <Header as="h3" textAlign="center" color={'green'}>
            Dashboard do Cliente
        </Header>
        <Table.Row>
            <Table.HeaderCell colSpan="4">
                <Button onClick={toggleFilters} color={"green"}>
                    <Icon name={showFilters ? 'hide' : 'unhide'}/>
                    {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                </Button>
            </Table.HeaderCell>
        </Table.Row>
        {!showFilters && (
            <Segment>
                <Grid stackable doubling padded>
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Form.Group widths='equal'>
                                <Form.Field
                                    width={'6'}
                                    control={Select}
                                    fluid
                                    label="Cliente"
                                    placeholder="Cliente"
                                    search
                                    selection
                                    options={clients}
                                    value={clientId}
                                    onChange={(_: React.ChangeEvent<HTMLInputElement>, data: { value: string; }) => {
                                        setClientId(data.value);
                                        setFilter({...filter, clientId: data.value});
                                    }}
                                />
                            </Form.Group>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <label htmlFor="month">Mês</label> {/* Label para o campo "Mês" */}
                            <Form.Field
                                width={'4'}
                                control={Select}
                                fluid
                                placeholder="Mês"
                                search
                                selection
                                required
                                options={EMes}
                                value={filter?.Month}
                                onChange={(_: React.ChangeEvent<HTMLInputElement>, data: { value: string; }) => {
                                    setFilter({...filter, Month: Number(data.value as string)});
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <label htmlFor="year">Ano</label> {/* Label para o campo "Ano" */}
                            <Form.Field
                                width={'4'}
                                control={Input}
                                fluid
                                placeholder="2023"
                                required
                                type="number"
                                value={filter?.Year}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    setFilter({
                                        ...filter,
                                        Year: Number(e.target.value),
                                    })
                                }
                            />
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="bottom">
                            <Button color={"green"} onClick={getClientDashboardData}>Buscar</Button>
                        </Grid.Column>
                    </Grid.Row>
                    {(!clientId || !filter?.Month || !filter?.Year) && (
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Message
                                    icon={'info'}
                                    size={'small'}
                                    info
                                    content={"Preencha os filtros para continuar."}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            </Segment>
        )}


        {clientDashboardData && <Segment>
                <Header as="h3" textAlign="center" color={'green'}>
                    Dashboard do Cliente: {clientDashboardData?.clientName}
                </Header>

                {clientDashboardData && (
                    <Grid>
                        <Grid.Row columns={2} divided centered>
                            <Grid.Column width={8}>
                                <Header as="h3" textAlign="center" color={'black'}>
                                    Atingimento de Inércia
                                </Header>
                                <CircularProgressBar percentage={clientDashboardData.inertiaPrizePercentage}
                                                     size={300}/>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Header as="h3" textAlign="center" color={'black'}>
                                    Atingimento de Carga no Motor
                                </Header>
                                <CircularProgressBar percentage={clientDashboardData.motorLoadPrizePercentage}
                                                     size={300}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
                <br/>
                {clientDashboardData && (
                    <Segment>
                        <Grid columns={2} divided>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <Header as="h3" textAlign="center" color={'green'}>
                                        Ranking Top Inércia
                                    </Header>
                                    <Table color={"green"}>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>#</Table.HeaderCell>
                                                <Table.HeaderCell>Motorista</Table.HeaderCell>
                                                <Table.HeaderCell>Cpf</Table.HeaderCell>
                                                <Table.HeaderCell>Inércia %</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {clientDashboardData && clientDashboardData.driversByInertia ? (
                                                clientDashboardData.driversByInertia.map((driver: DriverDataDto, driverIndex: number) => (
                                                    <Table.Row key={driverIndex}>
                                                        <Table.Cell disabled
                                                                    textAlign="right">#{driverIndex + 1}</Table.Cell>
                                                        <Table.Cell>
                                                            <b>{driver.driverName ?? '-------'}</b>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <b>{StringUtils.formatCPF(driver.driverCpf)}</b>
                                                        </Table.Cell>
                                                        <Table.Cell>{`${StringUtils.toBrazilianDecimalFormat(driver.inertiaPercentage) ?? ' - '}%`}</Table.Cell>

                                                    </Table.Row>
                                                ))
                                            ) : (
                                                <Table.Row>
                                                    <Table.Cell colSpan={9}>Nenhum registro encontrado.</Table.Cell>
                                                </Table.Row>
                                            )}                            </Table.Body>
                                    </Table>
                                </Grid.Column>
                                <Grid.Column>
                                    <Header as="h3" textAlign="center" color={'green'}>
                                        Ranking Top Carga no Motor
                                    </Header>
                                    <Table color={"green"}>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>#</Table.HeaderCell>
                                                <Table.HeaderCell>Motorista</Table.HeaderCell>
                                                <Table.HeaderCell>Cpf</Table.HeaderCell>
                                                <Table.HeaderCell>Carga Motor %</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {clientDashboardData && clientDashboardData.driversByMotorLoad ? (
                                                clientDashboardData.driversByMotorLoad.map((driver: DriverDataDto, driverIndex: number) => (
                                                    <Table.Row key={driverIndex}>
                                                        <Table.Cell disabled
                                                                    textAlign="right">#{driverIndex + 1}</Table.Cell>
                                                        <Table.Cell>
                                                            <b>{driver.driverName ?? '-------'}</b>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <b>{StringUtils.formatCPF(driver.driverCpf)}</b>
                                                        </Table.Cell>
                                                        <Table.Cell>{`${StringUtils.toBrazilianDecimalFormat(driver.motorLoadPercentage) ?? ' - '}%`}</Table.Cell>
                                                    </Table.Row>
                                                ))
                                            ) : (
                                                <Table.Row>
                                                    <Table.Cell colSpan={9}>Nenhum registro encontrado.</Table.Cell>
                                                </Table.Row>
                                            )}

                                        </Table.Body>
                                    </Table>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
                )}

            </Segment>}
        {!clientDashboardData
            && (clientId && filter?.Month && filter?.Year)
            && <Segment>
                {'Nenhum dado encontrado para o cliente/período selecionado.'}
            </Segment>}
    </div>;
};

export default ClientDashboardPage;
